import isModel from './isModel'
function setRootFontSize () {
  var width = document.documentElement.clientWidth || document.body.clientWidth
  var fontSize = width / 375 * 100
  document.getElementsByTagName('html')[0].style['font-size'] = fontSize + 'px'
}
function setRootFontSize2 () {
  var width = document.documentElement.clientWidth || document.body.clientWidth
  var fontSize;
  if (width >= 1920) {
    fontSize = 100
  } else {
    fontSize = width / 1920 * 100
  }
  document.getElementsByTagName('html')[0].style['font-size'] = fontSize + 'px'
}
var isPc = isModel()
if (isPc) {
  setRootFontSize2()
} else {
  setRootFontSize()
}
window.addEventListener('resize', function () {
  var isPc = isModel()
  if (isPc) {
    setRootFontSize2()
  } else {
    setRootFontSize()
  }
})
